import React from 'react';

import Badge from '../Badge';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../../utils/handlers';

export default function CompletedBadge({ isCompleted, isVerified, shortened, className, handleClick }) {
  if (!(isCompleted || isVerified)) {
    return null;
  }

  let title;
  if (!shortened) {
    title = isVerified ? StringConstantsMixin.strings.FILTERS.VERIFIED : StringConstantsMixin.strings.FILTERS.COMPLETED;
  }

  const classes = [styles[isVerified ? 'verified' : 'unverified']];
  if (className) {
    classes.push(className);
  }
  if (shortened) {
    classes.push(styles.shortened);
  }

  return (
    <Badge className={classes.join(' ')} handleClick={wrapEventHandler(handleClick)}>
      <img className={styles.checkmark} src="//cdn-assets.alltrails.com/assets/icons/trail/vc-check-mark@2x.png" />
      {title}
    </Badge>
  );
}
